export const US_NEWS_LOGO =
  "https://images.cdn.edx.org/attachment-19341210125-bestonlineprogramsbadge-graphic.png";
